import React, {useEffect, useState} from 'react'
import {Button, Modal, Spinner} from 'react-bootstrap'
import {useFormik} from 'formik'
import {useParams} from 'react-router-dom'
import {useAuth} from '../../modules/auth'
import {useDispatch, useSelector} from 'react-redux'
import {Dispatch} from '@reduxjs/toolkit'
import {setIsCardUpdated} from '../../store/slice/last-update-slice'
import {fetchAllCardsofLoggedInUser, fetchAllCardByBoardId} from '../../store/slice/card-slice'
import {awsFileUploadConfig} from '../../config/awsFileUpload'
import {
  useFileUploader,
  // useGetAllBoards,
  useGetColumns,
  useBoardPersons,
  useWebSocketHook,
} from '../../hooks'
import {getTimeDateFormate} from '../../helper-functions/TimeFormate'
import {countCardNumbers, findAndAddCardPosition} from '../../helper-functions/findCardNumAndPos'
import ReactS3Client from 'react-aws-s3-typescript'
import AddCardForm from '../Forms/AddCardForm'
import {createCard, getHomeColumnCounts} from '../../services/cards'
import * as Yup from 'yup'
import {webSocketOperations} from '../../constants'
import {capitalizeEachWord} from '../../helper-functions/CapitalizeName'
import useSendAlert from '../../hooks/useSendAlert'
import {removeNullFromReminder} from '../../helper-functions/RemoveNullFromReminders'
import '../../styles/updateanaddform.css'
import {useTheme} from '../../context/ThemeContext'
import useGetTags from '../../hooks/useGetTags'
import { applyColumnRules } from '../../utils/applyColumnRules'
import { addBoardTags } from '../../store/slice/board-tags-slice'
import { cleanMentions } from '../../utils/cleanMentions'

const cardSchema = Yup.object().shape({
  cardName: Yup.string()
    .min(3, 'Minimum 3 Characters')
    .max(300, 'Maximum 300 Characters')
    .required('Task Name is Required')
    .trim(),
  status: Yup.string().required('Status is Required'),
})

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const AddNewCard = ({
  cardPositionStatus,
  columnTitle,
  columnIdProp,
  cardTitle,
  cardModalShow,
  setCardModalShow,
  setCards,
  role,allCards,
  columnResponse
}: any): React.JSX.Element => {
  const {theme} = useTheme()
  const params: any = useParams()
  const [editorDescriptionState, setEditorDescriptionState] = useState<any>(null)
  const [isExpanded, setIsExpanded] = useState(false)
  const [disableBtn, setDisableBtn] = useState(false)
  const [boardId, setBoardId] = useState(params.boardId)
  const [columnId, setColumnId] = useState('')
  const [startDate, setStartDate] = useState<any>(null)
  const [selectedTags, setSelectedTags] = useState<any>([])
  const [mentions, setMentions] = useState<any>([])
  const { tags, loading:tagsLoading } = useGetTags(boardId)

  // const [isSendAlert, setIsSendAlert] = useState(false)
  const {currentUser} = useAuth()
  const {id: userId, fullName} = currentUser?.data.user
  const dispatch: Dispatch<any> = useDispatch()
  const {allBoards} = useSelector((state: any) => state.allBoardsReducer)

  const isLastUpdated = useSelector((state: any) => state.lastUpdateReducer)
  const {isCardUpdated} = isLastUpdated.isCardUpdated

  const boardFromReducer = useSelector((state: any) => state.boardReducer)
  const {data: boards} = boardFromReducer?.entities
  const {sendJsonMessage}: any = useWebSocketHook()
  const s3 = new ReactS3Client({
    ...awsFileUploadConfig,
    dirName: `cards-attachments/${process.env.REACT_APP_ENVIRONMENT}`,
  })
  // const {allBoards} = useGetAllBoards()
  const {selectedFile, selectFileHandler, deleteFileHandler, fileErrorMsg, setFileErrorMsg} =
    useFileUploader()
  const [reminders, setReminders] = useState<any>([])
  const board = boards?.filter((item: any) => params.boardId === item.board.id)
  const {columnResponse: columns, fetchColumnHandler} = useGetColumns(boardId || params.boardId)
  const {
    boardPersonsForSendAlert,
    optionsOfAssignee,
    optionsForSendAlert,
    selectAutoAssignee,
    setSelectAutoAssignee,
    getBoardPersonHandler,
    isUserAssignLoading
  } = useBoardPersons()

  const {  sendAlertMsg, setSendAlertMsg, sendAlertToMentionPerson} =
    useSendAlert(boardPersonsForSendAlert, undefined, boardId, undefined, editorDescriptionState)
  // let {
  //     showVideo,
  //     setShowVideo,
  //     video,
  //     setVideo,
  //     isVideoSrcGet,
  //     setIsVideoSrcGet,
  //     imageSrc,
  //     setImageSrc,
  //     show,
  //     setShow,
  //     editor,
  //     setEditor,
  // } = useUImageVideoPreview()
  const initialValues = {
    cardName: '',
    dueDate: '',
    dueTime: '',
    boardName: board?.length > 0 ? board[0]?.board?.name?.trim() : '',
    columnName: columnTitle,
    status: 'todo',
    priority: undefined,
  }

  const handleFileUpload = async () => {
    const urls = []
    for (let index = 0; index < selectedFile?.length; index++) {
      const filename = selectedFile[index].name
      if (filename) {
        const filenameUpdated = filename?.substring(0, filename?.lastIndexOf('.'))
        try {
          const uploadFile: any = await s3.uploadFile(selectedFile[index], filenameUpdated)
          urls.push(uploadFile.location)
        } catch (error) {
          return error
        }
      }
    }
    return urls
  }

  const columnScrollHandler = () => {
    setTimeout(() => {
      if (cardPositionStatus === 'down') {
        const elements = document.getElementsByClassName('custom-class1')
        for (let i = 0; i < elements.length; i++) {
          const element = elements[i]
          const droppableId = element.getAttribute('data-rbd-droppable-id')
          if (droppableId === columnId) {
            element.scrollTop = element?.scrollHeight
          }
        }
      } else {
        const elements = document.getElementsByClassName('custom-class1')
        for (let i = 0; i < elements.length; i++) {
          const element = elements[i]
          const droppableId = element.getAttribute('data-rbd-droppable-id')
          if (droppableId === columnId) {
            element.scrollTop = 0
          }
        }
      }
    }, 1500)
  }
  const formik = useFormik({
    initialValues,
    validationSchema: cardSchema,
    enableReinitialize: true,
    onSubmit: async (values, {resetForm}) => {
      setDisableBtn(true)
      const fileLinks = await handleFileUpload()
      const {cardLength} = await countCardNumbers(boardId, userId)
      const {utcDate, utcTime}: any = getTimeDateFormate(startDate)
      const position = findAndAddCardPosition(cardLength, cardPositionStatus)

      // Calculate home_position from home column counts API (min/max)
      let home_position = position // fallback
      try {
        const countsRes = await getHomeColumnCounts()
        const counts = countsRes.data.data
        const statusKey = values.status || 'todo'
        const columnData = counts[statusKey]
        if (columnData && columnData.count > 0) {
          home_position = cardPositionStatus === 'top' ? columnData.min - 1 : columnData.max + 1
        } else {
          home_position = cardPositionStatus === 'top' ? -1 : 1
        }
      } catch {
        // fallback: use board position if home counts unavailable
      }

      const postDataBeforeRule = {
        created_by: fullName,
        last_modified_by: fullName,
        board_name: allBoards?.find((item: any) => item?.board?.id === boardId)?.board?.name?.trim(),
        card_name: values.cardName,
        description: editorDescriptionState && editorDescriptionState.length > 0 ? cleanMentions(editorDescriptionState)  : null,
        due_date: startDate === null ? null : utcDate,
        due_time: startDate === null ? null : utcTime,
        position,
        home_position,
        priority: values.priority === undefined ? null : values.priority,
        rag: null,
        status: values.status,
        version: 1,
        applicationId: null,
        boardId: boardId,
        board_column_id: columnId,
        categoryId: null,
        componentId: null,
        customerId: null,
        productId: null,
        typeId: null,
        reporter: fullName,
        cardType: 'individual',
        organizationId: null,
        tagIds: selectedTags.length > 0 ? selectedTags.map((tag: any) => { return tag.value} ) : [],
        assignees:
          optionsOfAssignee.length > 0
            ? selectAutoAssignee.map((item: any) => {
                return {
                  board_person_id: item.value,
                }
              })
            : [],
        file_attachments: fileLinks,
        reminders: removeNullFromReminder(reminders as any),
      }
      const currentCol=columnResponse.find((col:any)=> col.id === columnId)
      const postData = applyColumnRules(postDataBeforeRule, currentCol);

      try {
        const res = await createCard(postData, userId)
        const newCard = res.data.data
        setCards([...allCards, newCard])
        // add new tags
        const addedTags = selectedTags?.map((tag: any) => ({ label: tag.label, value: tag.value }));
        addedTags.length && dispatch(addBoardTags(addedTags));

        const webSocketPayload: any = {
          event: 'publish',
          channel: boardId,
          userId,
          command: 'CREATE',
          operation: webSocketOperations.cardCreate,
          payload: {
            newCard,
            boardId,
            alert: `${capitalizeEachWord(fullName)} created a new card ${newCard.board_name}- ${
              newCard.number
            }.`,
          },
        }
        sendJsonMessage(webSocketPayload)
        dispatch(setIsCardUpdated({isCardUpdated: !isCardUpdated}))
        dispatch(fetchAllCardsofLoggedInUser())
        dispatch(fetchAllCardByBoardId({boardId: boardId, userId: userId}))
        // if (sendAlertTo.length > 0 && editorDescriptionState !== null)
        //   sendAlertToBoardPerson(newCard, sendAlertTo, 'card-description')
        if (mentions.length > 0 && editorDescriptionState !== null)
          sendAlertToMentionPerson(newCard,mentions, 'card-description')

        // if(!isSendAlert){
        setCardModalShow(false)
        resetForm()
        // }

        columnScrollHandler()
      } catch (error) {
        return error
      }

      setTimeout(() => {
        setDisableBtn(false)
        // setIsSendAlert(false)
        // setSendAlertMsg("")
      }, 4000)
    },
  })

  useEffect(() => {
    if (boardId) {
      fetchColumnHandler(boardId)
      getBoardPersonHandler(boardId)
    }
    //eslint-disable-next-line
  }, [boardId])

  return (
    <>
      <Modal
        show={cardModalShow}
        contentClassName={theme === 'dark' ? 'theme__div' : ''}
        dialogClassName={`modal-dialog-expandable ${isExpanded ? 'modal-dialog-expanded' : ''}`}
        size='xl'
        aria-labelledby='contained-modal-title-vcenter'
        animation={false}
        onHide={() => {
          if (isExpanded) {
            setIsExpanded(false)
            return
          }
          setCardModalShow(false)
          formik.resetForm()
        }}
        scrollable
        className='modal-backdrop.show'
      >
        <div className='row d-flex justify-content-between border-bottom fs-2 fw-bold p-8'>
          <div className={`col-6 ${theme === 'dark' ? 'white__text' : ''}`}>{cardTitle}</div>
          <div className='col-4 text-end'>
            <Button
              disabled={!allBoards?.length || !boardId?.length || !columnId  || disableBtn}
              className={`${disableBtn && 'btn-custom-secondary '} btn-sm w-75`}
              onClick={() => {
                formik.handleSubmit()
              }}
            >
              {disableBtn ? <Spinner animation='border' variant='light' /> : 'Save'}
            </Button>
          </div>
          <div className='col-1 d-flex align-items-center justify-content-end gap-1'>
            <button
              type='button'
              className='expand-minimize-btn'
              onClick={() => setIsExpanded(!isExpanded)}
              title={isExpanded ? 'Minimize' : 'Expand to full screen'}
            >
              <i className={`bi ${isExpanded ? 'bi-fullscreen-exit' : 'bi-arrows-fullscreen'} fs-3`}
                 style={{ color: theme === 'dark' ? '#ff7c00' : '#6c757d' }}
              ></i>
            </button>
            <span
              className='text-center p-2 cursor-pointer d-inline-block pb-0'
              onClick={() => setCardModalShow(false)}
            >
              X
            </span>
          </div>
        </div>
        <Modal.Body>
          <div className={isExpanded ? 'container-fluid' : 'container'}>
            <AddCardForm
              formik={formik}
              allBoardsVar={allBoards}
              setBoardId={setBoardId}
              boardId={boardId}
              columnTitle={columnTitle}
              columnIdProp={columnIdProp}
              columns={columns}
              setColumnId={setColumnId}
              columnId={columnId}
              selectedFile={selectedFile}
              deleteFileHandler={deleteFileHandler}
              changeHandler={selectFileHandler}
              setStartDate={setStartDate}
              startDate={startDate}
              options={optionsOfAssignee}
              setSelected={setSelectAutoAssignee}
              isUserAssignLoading={isUserAssignLoading}
              selected={selectAutoAssignee}
              disableBtn={disableBtn}
              board={board}
              fileErrorMsg={fileErrorMsg}
              setFileErrorMsg={setFileErrorMsg}
              setEditor={setEditorDescriptionState}
              editor={editorDescriptionState}
              optionsForSendAlert={optionsForSendAlert}
              sendAlertMsg={sendAlertMsg}
              setSendAlertMsg={setSendAlertMsg}
              reminders={reminders}
              setReminders={setReminders}
              tags={tags}
              setSelectedTags={setSelectedTags}
              selectedTags={selectedTags}
              tagsLoading={tagsLoading}
              role={role}
              setMentions={setMentions}
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default AddNewCard
